import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { SaleDetail } from '../../types/sale';
import { SaleMapperHelper } from '../../utils/mappers/sale';
import {
  setActiveBranchId,
  setActiveDocumentType,
  setSaleForm,
  updateSaleTotalsView,
} from '../../store/slices/sale/saleSlice';
import useProductCatalog from '../productpanel/useProductCatalog';

/** Hidrata y abre el checkout existente desde cualquier conversión a venta. */
const useContinueSale = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { resetProductPanelState } = useProductCatalog();

  return useCallback(
    (continuation: SaleDetail) => {
      const saleForm = SaleMapperHelper.mapToSaleFormValues(continuation);

      dispatch(setSaleForm(saleForm));
      dispatch(setActiveDocumentType(saleForm.documentType));
      dispatch(updateSaleTotalsView(saleForm.totalsView));
      dispatch(setActiveBranchId(saleForm.branch!.id));
      resetProductPanelState();
      navigate('/sale-register');
    },
    [dispatch, navigate, resetProductPanelState]
  );
};

export default useContinueSale;
